import metadata from './AddHouseholdMemberPopup.metadata.json5';
import styles from './AddHouseholdMemberPopup.module.scss';
import householdMessages from './HouseholdMembers.messages';

export default {
    metadata,
    styles,
    householdMessages
};
